import * as tslib_1 from "tslib";
import { Api } from './api';
import * as i0 from "@angular/core";
import * as i1 from "./api";
var UserApi = /** @class */ (function () {
    function UserApi(api) {
        this.api = api;
        this.userProperties = 'id, email, firstName, lastName';
        this.publicUserProperties = 'id, firstName, lastName';
        this.userFolderProperties = 'applicationId, category, createdDate, displayOrder, id, lastEditedDate, maps, name, parentUserFolderId, userId';
    }
    UserApi.prototype.getUsers = function (id, canViewSensitiveData) {
        if (canViewSensitiveData === void 0) { canViewSensitiveData = true; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var queryType, userProperties;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryType = canViewSensitiveData ? 'users' : 'publicUsers';
                        userProperties = canViewSensitiveData ? this.userProperties : this.publicUserProperties;
                        return [4 /*yield*/, this.api.http2.graphqlRequest("query GetUsers($id: [Int]) {\n                " + queryType + "(id: $id){\n                    " + userProperties + "\n                }\n            }", { id: id }, 'GET', queryType)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    UserApi.prototype.queryUsers = function (queryArgs, properties) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var props;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        props = properties ? properties : this.userProperties;
                        return [4 /*yield*/, this.api.http2.graphqlRequest("query queryUsers() {\n                users(" + queryArgs + "){\n                     " + props + "\n                }\n            }", {}, 'GET', 'users')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    UserApi.prototype.searchUsers = function (search, first, publicData) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var queryType, columns;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryType = publicData ? 'publicUsers' : 'users';
                        columns = ['department', 'id', 'firstName', 'lastName'];
                        if (!publicData) {
                            columns.push('email');
                        }
                        if (!first) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.api.http2.graphqlRequest("query  {\n                " + queryType + "(search: \"" + search + "\", first: " + first + " ){\n                    " + columns + "\n                }\n            }", null, 'GET', queryType)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2: return [4 /*yield*/, this.api.http2.graphqlRequest("query {\n                " + queryType + "(search: \"" + search + "\"){\n                    " + columns + "\n                }\n            }", { search: search }, 'GET', queryType)];
                    case 3: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    UserApi.prototype.queryUserFolders = function (userId, appId, category) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("query GetUserFolders($userId: [Int], $appId: [Int], $category: [String]) {\n            userFolder(applicationId: $appId, userId: $userId, category: $category) {\n                id\n                name\n                parentUserFolderId\n                applicationId\n                userId,\n                category\n            }\n        }", { userId: userId, appId: appId, category: category }, 'GET', 'userFolder')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    UserApi.prototype.createNewUserFolder = function (newFolder) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("mutation CreateNewUserFolder($folder: UserFolderInput!) {\n            saveUserFolder(userFolder: $folder) {\n                id\n                name\n                parentUserFolderId\n                userId\n                applicationId\n                category\n            }\n        }", { folder: newFolder }, 'POST', 'saveUserFolder')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    UserApi.prototype.deleteUserFolder = function (id) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("mutation {\n            deleteUserFolder(id: " + id + ")\n        }", null, 'GET', null)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    // async create(user) {
    //     return await this.api.http2.graphqlRequest(`
    //         mutation CreateUser($user: UserInput!){
    //             createUser(user: $user){
    //                 id
    //             }
    //         }
    //     `, { user: this.sanitize(user) }, 'POST', 'createuser.id');
    // }
    UserApi.prototype.update = function (user) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("\n                mutation UpdateUser($user: UserInput!){\n                    saveUser(user: $user){\n                        email\n                    }\n                }\n            ", { user: this.sanitize(user) }, 'POST', 'saveUser')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    UserApi.prototype.sanitize = function (user) {
        // only keep layer properties
        var result = this.api.pick(user, this.userProperties.split(', '));
        return result;
    };
    UserApi.prototype.registerUser = function (email) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.get('registerUser', { emailAddress: email })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    UserApi.ngInjectableDef = i0.defineInjectable({ factory: function UserApi_Factory() { return new UserApi(i0.inject(i1.Api)); }, token: UserApi, providedIn: "root" });
    return UserApi;
}());
export { UserApi };
